import React, { useEffect, useState, useCallback } from "react";
import { Button, Col, PageHeader, Row } from "antd";
import { Link } from "react-router-dom";
import MemberService from "../../api/member.service";
import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import MemberContinueComponent from "../../components/member/MemberContinue";
import CustomTableSearch from "../../components/common/CustomTableSearch";

const MemberContinuePage = () => {
  const [memberList, setMemberList] = useState([]);
  const [filteredSearchList, setFilteredSearchList] = useState([]);

  const fetchDiscontinuedMembers = useCallback(() => {
    MemberService.getAllDiscontinuedMembers().then((res) => {
      const data = res.data.response_data;
      setMemberList(data);
      setFilteredSearchList(data); // Set initial filtered list
    });
  }, []);

  const onSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filtered = memberList.filter((data) =>
      JSON.stringify(data).toLowerCase().includes(searchValue)
    );
    setFilteredSearchList(filtered);
  };

  useEffect(() => {
    fetchDiscontinuedMembers();
  }, [fetchDiscontinuedMembers]);

  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />
      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Membership List - Discontinued"
          extra={[
            <Link to={`/member-discontinue`} key="reg_list">
              <Button shape="round" className="custom-button-white">
                Add
              </Button>
            </Link>,
          ]}
        />
        <Row style={{ background: "transparent" }}>
          <Col xs={24} xl={24}></Col>
        </Row>
        <div className="tableView">
          <div className="form-content">
            <CustomTableSearch
              onSearchTable={onSearch}
              style={{ marginBottom: "8px" }}
            />
            <MemberContinueComponent
              MembershipList={filteredSearchList}
              onRefresh={fetchDiscontinuedMembers}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberContinuePage;
